import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { TeamMember } from '../../types/team.types';
import { useAppQuery } from '../use-app-query.hook';

// Cross-tenant admin data (internal CapQuest roster): intentionally not scoped to a single
// companyId — access is enforced server-side by AdminPanelGuard, not by the companies/:companyId
// path used by tenant-facing hooks.
export const useTeamMembers = () => {
  const queryClient = useQueryClient();

  const invalidate = useCallback(
    () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_TEAM_MEMBERS] }),
    [queryClient],
  );

  const { data, isLoading, isError } = useAppQuery<TeamMember[]>({
    queryKey: [QueryKey.GET_TEAM_MEMBERS],
    queryFn: () => ApiService.get({ endpoint: BackendRoute.TEAM_MEMBERS }),
  });

  return { members: data ?? [], isLoading, isError, invalidate };
};
